import ManualDomiciliation from '@/classes/procedure_executions/ManualDomiciliation'
import { omit as _omit, mapKeys as _mapKeys } from 'lodash'

export default class Informations {
  constructor ({ terms_of_use = false, sepa_mandate_terms = false, newsletter = null, sms_consent = null, message = null, manual_domiciliation = {}, ...informations }) {
    this.terms_of_use = terms_of_use
    this.sepa_mandate_terms = sepa_mandate_terms
    this.newsletter = newsletter
    this.message = message
    this.sms_consent = sms_consent
    this.manual_domiciliation = new ManualDomiciliation(manual_domiciliation)

    Object.assign(this, informations)
  }

  get to_database () {
    return {
      ...this,
      manual_domiciliation: this.manual_domiciliation.to_database
    }
  }

  get to_tamaro () {
    const custom_informations = _mapKeys(_omit(this, ['terms_of_use', 'newsletter', 'message', 'custom_fields', 'manual_domiciliation']), (value, key) => `stored_${key.replaceAll('-', '_')}`)
    const custom_fields = _mapKeys(this.custom_fields, (value, key) => `stored_custom_fields_${key.replaceAll('-', '_')}`)

    return {
      sepa_mandate_terms: this.sepa_mandate_terms,
      stored_customer_email_permission: this.newsletter || false,
      stored_customer_message: this.message,
      ...custom_informations,
      ...custom_fields,
      ...this.manual_domiciliation.to_tamaro
    }
  }
}
